<div class="slide-panel">
  <div class="slide-panel-title">
    <h6 class="flex-1">Filtres</h6>
    <oui-button
      type="icon"
      color="secondary"
      (click)="closeSlidePanel()">
      <oui-icon>close</oui-icon>
    </oui-button>
  </div>

  <div class="slide-panel-body">
    @if (editableRecherche()) {
      <oui-textfield
        class="width-100"
        label="Nom de la recherche"
        [control]="nomRechercheControl"></oui-textfield>
    }
    @for (line of localButtonLines(); track $index; let last = $last) {
      @if (line.builder) {
        <app-filtre-button-line
          [builder]="line.builder"
          [line]="line"
          [index]="$index"
          [last]="last"
          (lineChange)="onButtonLineChanged($event)"></app-filtre-button-line>
      }
    }
    <div class="padding-vertical-24 flex-vertical">
      <div class="flex-horizontal flex-center gap-8">
        <oui-icon>tune</oui-icon>
        <div class="subtitle-1">Filtres avancés</div>
      </div>
      <div class="padding-vertical-16">
        <oui-button
          type="text"
          iconPrefix="add_circle"
          [disabled]="lockAddCustomLine()"
          (click)="addCustomLine()"
          >Ajouter un critère de recherche</oui-button
        >
      </div>
      @for (item of localCustomLines(); track item.order) {
        <app-filtre-custom-line
          [line]="item"
          [index]="$index"
          (lineChange)="onCustomLineChanged($event)"
          (remove)="onRemoveCustomLine($event)"></app-filtre-custom-line>
      }
    </div>
  </div>

  <div class="slide-panel-footer">
    <oui-button
      type="text"
      (click)="onClear()"
      >Effacer</oui-button
    >
    @if (editableRecherche() && nomRechercheControl.valid) {
      <oui-button
        type="contained"
        (click)="onSave()"
        >Enregistrer</oui-button
      >
    } @else {
      <oui-button
        type="contained"
        (click)="onSearch()"
        >Rechercher</oui-button
      >
    }
  </div>
</div>
